import React from "react";
var __jsx = React.createElement;
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { filterDisplayableUrls } from 'libs/content/utils';
import { getUrls } from 'redux/content';
import { Container, Label, Link, StyledLinearProgress } from './MetaUrlField.style';

var MetaUrlField = function MetaUrlField(_ref) {
  var formField = _ref.formField;

  var _useSelector = useSelector(getUrls),
      urls = _useSelector.value,
      loading = _useSelector.loading;

  var displayableUrls = useMemo(function () {
    return filterDisplayableUrls(urls !== null && urls !== void 0 ? urls : []);
  }, [urls]);
  return __jsx(Container, null, __jsx(Label, null, __jsx(FormattedMessage, {
    id: formField.labelId
  }), " :", ' '), loading ? __jsx(StyledLinearProgress, null) : displayableUrls.length === 0 ? __jsx(FormattedMessage, {
    id: "url.undefined"
  }) : __jsx("ul", null, displayableUrls.map(function (_ref2) {
    var absoluteUrl = _ref2.absoluteUrl,
        pageConfigName = _ref2.pageConfigName;
    return __jsx("li", {
      key: pageConfigName
    }, __jsx(Link, {
      href: absoluteUrl,
      target: "_blank",
      rel: "noreferrer"
    }, absoluteUrl));
  })));
};

export default MetaUrlField;